/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WebSdkScanResultModel } from '../../models/web-sdk-scan-result-model';
import { WebSdkSessionSubmitResponseModel } from '../../models/web-sdk-session-submit-response-model';

export interface SessionSubmitWebSdkSessionPost$Params {
  
    /**
     * The web SDK scan result model containing scan data
     */
    body?: WebSdkScanResultModel
}

export function sessionSubmitWebSdkSessionPost(http: HttpClient, rootUrl: string, params?: SessionSubmitWebSdkSessionPost$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<WebSdkSessionSubmitResponseModel>> {
  const rb = new RequestBuilder(rootUrl, sessionSubmitWebSdkSessionPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<WebSdkSessionSubmitResponseModel>;
    })
  );
}

sessionSubmitWebSdkSessionPost.PATH = '/Session/SubmitWebSDKSession';
